module.exports = __webpack_public_path__ + "img/icon-chart@2x.b5677e5.png";